import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-decline-modal',
  templateUrl: './decline-modal.component.html',
  styleUrls: ['./decline-modal.component.scss'],
})
export class DeclineModalComponent implements OnInit {
  @Input() id: string;

  myForm = new FormGroup({
    reason: new FormControl(),
  });

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.myForm = this.formBuilder.group({
      reason: ['', [Validators.maxLength(500)]],
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.myForm.valid) {
      this.myForm.patchValue({
        reason: this.myForm.value.reason,
      } as any);
      // Note: createdBy, isActive, vegetationId are added to formData, not form
      console.log(this.myForm.value);
      this.modal.dismiss();
      this.router.navigate(['/listplants']);
    } else {
      this.myForm.markAllAsTouched();
    }
  }
}
